import React, {
  useContext,
  useState,
  useRef,
  forwardRef,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import SecuredImage from 'modules/common/components/SecuredImage';
import emptyStateImage from 'assets/img/no-result.svg';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import CmsContext from 'context/CmsContext';
import ProfileInformation from './ProfileInformation';
import * as actions from '../action';
import * as c from '../constant';
import ViewImage from './ViewImage';

// class ComponentToPrint extends React.Component {
const ComponentToPrint = forwardRef(({ src, rotation, heightWidth }, ref) => {
  const imgSrc = src;
  return (
    <SecuredImage
      ref={ref}
      onContextMenu={(e) => {
        e.preventDefault();
        return false;
      }}
      alt="BC"
      style={{
        transform: ` rotate(${rotation}deg)`,
        width: `${heightWidth}`,
        height: `${heightWidth}`,
      }}
      src={imgSrc}
    />
    // <embed src={src} title="BC Photo" />
  );
});

ComponentToPrint.propTypes = {
  src: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
  heightWidth: PropTypes.string.isRequired,
};

function FindMarriageCertificateModal({
  searchParams,
  getMarriageCertificatesArchive,
  marriageCertificatesArchiveList,
  isLoading,
  approveTransaction,
  showTransaction,
  id,
  approving,
  isCheckingArchive,
  type,
  isLoadingPhoto,
  permissions,
  transactionInfo
}) {
  const [heightWidth, setHeightWidth] = useState('auto');
  const [rotation, setRotation] = useState(0);
  const toPrintContentRef = useRef();
  const setModal = useContext(ModalContext);
  const [imgSrc, setImgSrc] = useState('');
  const [imgSide, setImgSide] = useState('');
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const getAdministrator = getJson('enableProfile');
  const isStartAssessment = _.get(transactionInfo, 'attributes.is_start_assessment');

  useEffect(() => {
    const combine = { ...searchParams, search_by: 'DETAILS' };
    getMarriageCertificatesArchive({
      ..._.pick(
        {
          husband_first_name: _.get(combine, 'husband_first_name'),
          husband_last_name: _.get(combine, 'husband_last_name'),
          husband_middle_name: _.get(combine, 'husband_middle_name'),
          wife_first_name: _.get(combine, 'wife_first_name'),
          wife_last_name: _.get(combine, 'wife_last_name'),
          wife_middle_name: _.get(combine, 'wife_middle_name'),
          date_marriage: _.get(combine, 'date_marriage'),
          search_by: _.get(combine, 'search_by'),
        },
        _.keys(c.FORM_DATA)
      ),
      search_by: 'DETAILS',
    });
  }, []);

  const onApprove = (e) => {
    e.preventDefault();

    approveTransaction(
      id,
      {
        status: 'PENDING',
      },
      () => {
        showTransaction(id);
        setModal({ isOpen: false });
      }
    );
  };

  const onReject = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Please input the reason.',
      (remarks) => {
        approveTransaction(
          id,
          {
            remarks,
            status: 'REJECTED',
          },
          () => {
            showTransaction(id);
            setModal({ isOpen: false });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const onShowFront = () => {
    setImgSrc('');

    const images = marriageCertificatesArchiveList.map((item) => {
      return item.images;
    });

    setImgSrc(_.get(images, '0.0.front_page'));
    setImgSide('front');
  };

  const onShowBack = () => {
    setImgSrc('');

    const images = marriageCertificatesArchiveList.map((item) => {
      return item.images;
    });
    setImgSrc(_.get(images, '0.1.back_page'));
    setImgSide('back');
  };

  const onForAppearance = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });

    ConfirmAlert(
      'Please input the reason.',
      (remarks) => {
        approveTransaction(
          id,
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(id);
            setModal({ isOpen: false });
          }
        );
      },
      () => setModal({ isOpen: true }),
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleGetPhoto = (data, side) => (e) => {
    e.preventDefault();

    setImgSide(side);
    if (side === 'front') {
      setImgSrc(_.get(data, 'front_page'));
    }
    if (side === 'back') {
      setImgSrc(_.get(data, 'back_page'));
    }
  };

  const onBack = (e) => {
    e.preventDefault();
    setImgSrc('');
  };

  const getTr = (item) => {
    let listImages = [];
    listImages = item.images;
    return listImages.map((marriageDetail, index) => (
      <tr
        // eslint-disable-next-line react/no-array-index-key
        key={`${_.get(item, 'id')}+${index}`}
        className="border-top"
      >
        <td>{`${_.get(item, 'registry_number')}`}</td>
        <td>
          {`${_.get(item, 'husband_first_name')}
            ${_.get(item, 'husband_middle_name') || ''}
            ${_.get(item, 'husband_last_name')} & ${_.get(
            item,
            'wife_first_name'
          )}
            ${_.get(item, 'wife_middle_name') || ''}
            ${_.get(item, 'wife_last_name')}`.toUpperCase()}
        </td>
        <td>{moment(_.get(item, 'date_marriage')).format('MM/DD/YYYY')}</td>
        <td style={{ textAlign: 'right' }}>
          <ViewImage
            item={marriageDetail}
            isLoading={isLoadingPhoto}
            handleGetPhoto={handleGetPhoto}
          />
        </td>
      </tr>
    ));
  };

  const onRotateLeft = (e) => {
    e.preventDefault();
    let newRotation = rotation - 90;
    if (newRotation === -360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [-90, 270, 90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };

  const onRotateRight = (e) => {
    e.preventDefault();
    let newRotation = rotation + 90;
    if (newRotation === 360) {
      newRotation = 0;
      setRotation(newRotation);
    }

    const rotationArray = [90, 270, -90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px');
    } else {
      setHeightWidth('auto');
    }

    setRotation(newRotation);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  if (isCheckingArchive || isLoading) {
    return (
      <Modal.Body>
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      </Modal.Body>
    );
  }

  // eslint-disable-next-line consistent-return
  const checkAdministratorAssessor = () => {
    if (isStartAssessment > 0) {
      return (
        +_.get(getAdministrator, 'id') === +_.get(transactionInfo, 'attributes.start_assess_by')
      );
    }
    if (isStartAssessment === 0) return true;
  };

  return (
    <Modal.Body>
      {!isEmpty(marriageCertificatesArchiveList) ? (
        <div className="row">
          <div className="col-12">
            {marriageCertificatesArchiveList.length ? (
              <div className="row">
                <div className="col-12 mt-3">
                  {imgSrc === '' && (
                    <table className="table table-borderless table-striped table-sm table-condensed">
                      <thead>
                        <tr>
                          <th scope="col">Registry Number</th>
                          <th scope="col">Name</th>
                          <th scope="col">Date of Marriage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marriageCertificatesArchiveList.map((item) =>
                          getTr(item)
                        )}
                      </tbody>
                    </table>
                  )}
                  {imgSrc !== '' && (
                    <>
                      <div div className="d-flex justify-content-between">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                            onClick={onBack}
                          >
                            <i className="fa fa-arrow-left" />
                            &nbsp;BACK
                          </button>
                          &nbsp;
                          {['FOR PICK-UP', 'ISSUED', 'FOR PRINTING'].indexOf(
                            _.get(transactionInfo, 'attributes.transaction_status')) > -1 &&
                            Acl(permissions, ['PRINT MARRIAGE CERTIFICATE']) && (
                              <ReactToPrint
                                trigger={() => (
                                  <button
                                    type="button"
                                    className="btn btn-primary cms-bg-color-primary cms-outline-primarybtn-md"
                                  >
                                    <i className="fa fa-print" />
                                    &nbsp;PRINT
                                  </button>
                                )}
                                content={() => toPrintContentRef.current}
                              />
                            )}
                          &nbsp;
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                            onClick={onRotateLeft}
                          >
                            <i className="fa fa-arrow-left" />
                            &nbsp;ROTATE LEFT
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                            onClick={onRotateRight}
                          >
                            ROTATE RIGHT&nbsp;
                            <i className="fa fa-arrow-right" />
                          </button>
                        </div>
                        <div>
                          {imgSide === 'back' ? (
                            <button
                              type="button"
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md mr-2"
                              onClick={onShowFront}
                            >
                              SHOW FRONT
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                              onClick={onShowBack}
                            >
                              SHOW BACK
                            </button>
                          )}
                        </div>
                      </div>
                      &nbsp;
                      <hr />
                      <div className="dc-wrapper d-flex justify-content-center">
                        <ComponentToPrint
                          rotation={rotation}
                          heightWidth={heightWidth}
                          src={imgSrc}
                          ref={toPrintContentRef}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center p-5">
                <img src={emptyStateImage} width={200} alt="No Data Found" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="card-section-content container-fluid citizen-tabs">
            <div className="right-section-content mt-0">
              {/* GRAY HIGHLIGHT */}
              <div className="row highlight d-flex align-items-center mx-3 py-3">
                <div className="col-12 px-0 mt-0 mb-1">
                  {/* BORDER */}
                  <div className="card border-primary">
                    <div className="container-fluid py-1">
                      <ProfileInformation data={searchParams} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_PROCESS_TYPE') === 'MANUAL' ? (
        <div className="d-flex justify-content-center">
          {type === 'check' && (
            <div className="d-flex align-items-center justify-content-center">
              {Acl(permissions, ['APPROVE MARRIAGE CERTIFICATE']) &&
              checkAdministratorAssessor() && (
                <button
                  style={{ width: '150px' }}
                  disabled={approving}
                  onClick={onApprove}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `APPROVE`
                  )}
                </button>
              )}
              {Acl(permissions, ['REJECT MARRIAGE CERTIFICATE']) &&
              checkAdministratorAssessor() && (
                <button
                  disabled={approving}
                  style={{ width: '150px' }}
                  onClick={onReject}
                  className="btn btn-danger mr-2"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `REJECT`
                  )}
                </button>
              )}
              {Acl(permissions, ['REJECT MARRIAGE CERTIFICATE']) && 
              checkAdministratorAssessor() && (
                <button
                  disabled={approving}
                  style={{ width: '150px' }}
                  onClick={onForAppearance}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                  type="button"
                >
                  {approving ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    `FOR APPEARANCE`
                  )}
                </button>
              )}
              <button
                disabled={isLoading}
                type="button"
                onClick={closeModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary"
              >
                CLOSE
              </button>
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="d-flex align-items-center justify-content-center">
            {type === 'check' && marriageCertificatesArchiveList.length > 0 && (
              <>
                {marriageCertificatesArchiveList.map((data) => (
                  <React.Fragment key={JSON.stringify(data)}>
                    {data.images.map(
                      (item) =>
                        !_.isEmpty(item.front_page) &&
                        !_.isEmpty(item.front_page) &&
                        Acl(permissions, ['APPROVE MARRIAGE CERTIFICATE']) &&
                        checkAdministratorAssessor() && (
                          <button
                            key={JSON.stringify(item)}
                            style={{ width: '150px' }}
                            disabled={approving}
                            onClick={onApprove}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                            type="button"
                          >
                            {approving ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              `APPROVE`
                            )}
                          </button>
                        )
                    )}
                  </React.Fragment>
                ))}
                {Acl(permissions, ['REJECT MARRIAGE CERTIFICATE']) &&
                checkAdministratorAssessor() && (
                  <button
                    disabled={approving}
                    style={{ width: '150px' }}
                    onClick={onReject}
                    className="btn btn-danger mr-2"
                    type="button"
                  >
                    {approving ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      `REJECT`
                    )}
                  </button>
                )}
                {Acl(permissions, ['REJECT MARRIAGE CERTIFICATE']) &&
                checkAdministratorAssessor() && (
                  <button
                    disabled={approving}
                    style={{ width: '150px' }}
                    onClick={onForAppearance}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                    type="button"
                  >
                    {approving ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                      `FOR APPEARANCE`
                    )}
                  </button>
                )}
                <button
                  disabled={isLoading}
                  type="button"
                  onClick={closeModal}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                >
                  CLOSE
                </button>
              </>
            )}
            {type === 'check' &&
              marriageCertificatesArchiveList.length === 0 && (
                <>
                  {Acl(permissions, ['REJECT MARRIAGE CERTIFICATE']) &&
                  checkAdministratorAssessor() && (
                    <button
                      disabled={approving}
                      style={{ width: '150px' }}
                      onClick={onReject}
                      className="btn btn-danger mr-2"
                      type="button"
                    >
                      {approving ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        `REJECT`
                      )}
                    </button>
                  )}
                  <button
                    disabled={isLoading}
                    type="button"
                    onClick={closeModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                  >
                    CLOSE
                  </button>
                </>
              )}
          </div>
        </>
      )}
      <div className="d-flex justify-content-center">
        {_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_PROCESS_TYPE') === 'MANUAL' && type === 'view' && (
          <button
            disabled={isLoading}
            type="button"
            onClick={closeModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
          >
            CLOSE
          </button>
        )}
      </div>
    </Modal.Body>
  );
}
FindMarriageCertificateModal.propTypes = {
  id: PropTypes.string.isRequired,
  searchParams: PropTypes.instanceOf(Object).isRequired,
  marriageCertificatesArchiveList: PropTypes.instanceOf(Array).isRequired,
  getMarriageCertificatesArchive: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  isCheckingArchive: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  isLoadingPhoto: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  marriageCertificatesArchiveList:
    _.get(api, `${c.GET_MARRIAGE_ARCHIVE}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_MARRIAGE_ARCHIVE) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
  isCheckingArchive: api.loading.indexOf(c.GET_MARRIAGE_ARCHIVE) > -1,
  isLoadingPhoto: api.loading.indexOf(c.GET_PHOTO) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(FindMarriageCertificateModal);
